'use client';
import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { useAuth } from '@/contexts/AuthContext';

const CTASection = () => {
  const router = useRouter();
  const { user, loading } = useAuth();

  useEffect(() => {
    const reveals = document.querySelectorAll('.reveal')
    if (!reveals?.length) return
    
    const observer = new IntersectionObserver(
      (entries) => entries.forEach(e => e.isIntersecting && e.target.classList.add('active')),
      { threshold: 0.1 }
    )
    reveals?.forEach(el => observer?.observe(el))
  }, [])

  const handleGetStarted = async () => {
    if (loading) return;

    if (!user) {
      // Redirect to signup with return URL
      router?.push('/sign-up-login?redirect=checkout');
    } else {
      // User is authenticated, redirect to checkout
      try {
        const response = await fetch('/api/create-checkout-session', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
        });

        const data = await response?.json();

        if (data?.url) {
          window.location.href = data?.url;
        } else {
          console.error('Failed to create checkout session:', data?.error);
          alert('Failed to start checkout. Please try again.');
        }
      } catch (error) {
        console.error('Checkout error:', error);
        alert('An error occurred. Please try again.');
      }
    }
  };

  return (
    <section className="relative py-32 bg-background overflow-hidden">
      {/* Gradient Overlays */}
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-primary/10 rounded-full blur-3xl" />
      <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-accent/10 rounded-full blur-3xl" />

      <div className="container relative z-10 px-6">
        <div className="max-w-4xl mx-auto text-center reveal">
          <h2 className="text-3xl sm:text-4xl md:text-6xl font-bold text-foreground tracking-tight mb-4 sm:mb-6">
            Start Your Aviation
            <span className="block text-primary">Journey Today</span>
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-muted-foreground mb-8 sm:mb-10 max-w-2xl mx-auto">
            Join thousands of aviation students who are preparing for their exams with Airframepowerplantprep. Start for free today.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={handleGetStarted}
              disabled={loading}
              className="inline-flex items-center justify-center px-8 sm:px-10 py-3 sm:py-4 text-sm sm:text-base font-semibold text-primary-foreground bg-primary rounded-full hover:bg-primary/90 transition-all shadow-xl hover:shadow-2xl disabled:opacity-50 disabled:cursor-not-allowed w-full sm:w-auto"
            >
              {loading ? 'Loading...' : user ? 'Subscribe Now' : 'Get Started'}
            </button>
          </div>

          <p className="text-xs sm:text-sm text-muted-foreground mt-6 sm:mt-8">
            {user ? 'Secure payment powered by Stripe' : 'No credit card required • Free forever • 500+ questions'}
          </p>
        </div>
      </div>
    </section>
  )
}

export default CTASection